import { useCallback, useContext } from 'react'

import useThreeDModelUploader from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/Hooks/useThreeDModelUploader'
import { openSignInModal, openThreeDModelPicker } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

// Shared behaviour for every "bring your own 3D model" entry point - the header button and
// the sidebar library cards: they all open the picker, which carries the upload as its first
// tile. The picker needs an account, so a signed-out visitor is sent to sign up instead.
export default function useThreeDModelEntryPoint() {
  const { userLoggedIn } = useContext(ThreeDStudioPageContext)
  const { isLoading } = useThreeDModelUploader()

  const handleClick = useCallback(() => {
    if (!userLoggedIn) {
      openSignInModal('signup')
      return
    }
    openThreeDModelPicker()
  }, [userLoggedIn])

  return { isLoading, onClick: handleClick }
}
